import { IconType } from '../../shared/services/icon.service';
import { to, Cmd } from './routes';

export interface AdminNavItem {
  routerLink: Cmd;
  title: string;
  icon: IconType;
}

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  {
    routerLink: to.adminBookings(),
    title: 'Buchungen',
    icon: IconType.CALENDAR
  },
  {
    routerLink: to.adminCategories(),
    title: 'Kategorien',
    icon: IconType.CATEGORY
  },
  {
    routerLink: to.adminCourts(),
    title: 'Plätze',
    icon: IconType.COURT
  },
  {
    // ONE entry for one page. "Kurse verwalten" and "Platzsperren &
    // Veranstaltungen" administered the same table from two sides and were
    // merged; the old `/admin/courses` entry was deleted with its route
    // (2026-09-01), so this is the only admin door onto that table.
    //
    // The name deliberately omits Platzsperren, which the page also lists: it
    // is the two things an admin comes looking for, not an inventory of what
    // the page can hold.
    routerLink: to.adminCourtBlocks(),
    title: 'Kurse & Events',
    icon: IconType.BOOK
  },
  {
    routerLink: to.adminPricingRules(),
    title: 'Preisregeln',
    icon: IconType.EURO
  },
  {
    routerLink: to.adminPricingOverview(),
    title: 'Preisübersicht',
    icon: IconType.BAR_CHART
  },
  {
    routerLink: to.adminVouchers(),
    title: 'Gutscheine',
    icon: IconType.VOUCHER
  },
  {
    routerLink: to.adminSubscriptions(),
    title: 'Abonnements',
    icon: IconType.REFRESH
  },
  {
    routerLink: to.adminMembershipTypes(),
    title: 'Mitgliedschaften',
    icon: IconType.TAG
  },
  {
    routerLink: to.adminGuestAllowance(),
    title: 'Gästekontingente',
    icon: IconType.USERS
  },
  {
    routerLink: to.adminUsers(),
    title: 'Benutzer',
    icon: IconType.USERS
  },
  {
    routerLink: to.adminRefundRequests(),
    title: 'Stornierungsanfragen',
    icon: IconType.TICKET
  },
  {
    routerLink: to.adminPayments(),
    title: 'Zahlungen',
    icon: IconType.CREDIT_CARD
  },
  {
    routerLink: to.adminOrganizationSettings(),
    title: 'Einstellungen',
    icon: IconType.SETTINGS
  },
];
